import type { SxStyle } from '@aibees/shared/theme';

export const root: SxStyle = {};

export const popoverSlot: SxStyle = {};

export const popoverPaper: SxStyle = {};

export const itemWrapper: SxStyle = {};

export const checkbox: SxStyle = {
  padding: 0,
};

export const advanceTableSelectionPopupItem: SxStyle = {
  padding: (p) => p.spacing(0.5),
  gap: 0.5,
};

export const advanceTableSelectionPopupItemText: SxStyle = {
  '& > span': {
    fontSize: (p) => `${p.typography.body4.fontSize} !important`,
    fontWeight: 500,
    color: (p) => p.palette.grey[800],
  },
};
